import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setWidth } from '../actions/event-series';
import { getNumberOfMonths,
    getFormattedStartMonth,
    getFormattedEndMonth,
    getDisabledDates,
    getFormattedSoldOutDates,
    getFormattedEventDates,
    getCalendarColors,
    seriesHasSchedule
} from '../selectors/eventSeries';

import { getModifiers, getStyleModifiers } from '../../../helpers/series';
import IntlDayPicker from '@showclix/components/IntlDayPicker';
import { createLoadingSelector } from 'checkout/selectors/helpers';
import { ISOStringToDate } from "../../../../helpers/time";

/**
 * Wrapper that connects IntlDayPicker to redux
 */
class SeriesDayPicker extends Component {

    componentDidMount = () => {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    updateDimensions = () => {
        this.props.setWidth(window.innerWidth);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    render() {
        if (!this.props.hasSchedule) {
            return null;
        }

        const modifiers = getModifiers(this.props.eventDates, this.props.calendarColors, this.props.inventoryFilterResults);
        const calendarStyle = getStyleModifiers(this.props.accentColor, modifiers);
        const allModifiers = {
            ...modifiers,
            soldOutDays: this.props.soldOutDays
        };

        if (this.props.selectedDay) {
            allModifiers.selectedDay = new Date(this.props.selectedDay);
        }

        let providedProps = {...this.props};
        if (this.props.loading) {
            providedProps.onDayClick = () => {
                //do nothing
            };
        }

        if (this.props.currentMonth) {
            providedProps.month = ISOStringToDate(this.props.currentMonth);
        }

        return (
            <IntlDayPicker
                locale={this.props.locale}
                modifiers={allModifiers}
                pagedNavigation={false}
                calendarStyle={calendarStyle}
                numberOfMonths={this.props.numberOfMonths}
                canChangeMonth={!this.props.loading}
                className={this.props.fullLoading ? 'loading loading--full' : (this.props.loading ? 'loading' : 'loaded')}
                {...providedProps}
            />
        );
    }
};

SeriesDayPicker.propTypes = {
    locale: PropTypes.string.isRequired,
    selectedDay: PropTypes.string,
    startingMonth: PropTypes.instanceOf(Date),
    endingMonth: PropTypes.instanceOf(Date),
    selectedDays: PropTypes.array.isRequired,
    disabledDays: PropTypes.array,
    onDayClick: PropTypes.func.isRequired,
    onMonthChange: PropTypes.func.isRequired,
};

const calendarLoading = createLoadingSelector("SERIES_CALENDAR");
const inventoryFilterLoading = createLoadingSelector("INVENTORY_FILTER");
const mapStateToProps = (state) => {
    //all kinds of things crash here if the series does not have a schedule
    let hasSchedule = seriesHasSchedule(state);

    if (!hasSchedule) {
        return {
            locale: state.intl.locale,
            selectedDays: [],
            hasSchedule,
        };
    }

    return {
        locale: state.intl.locale,
        numberOfMonths: getNumberOfMonths(state),
        fromMonth: getFormattedStartMonth(state),
        initialMonth: getFormattedStartMonth(state),
        toMonth: getFormattedEndMonth(state),
        disabledDays: getDisabledDates(state),
        soldOutDays: getFormattedSoldOutDates(state),
        eventDates: getFormattedEventDates(state),
        calendarColors: getCalendarColors(state),
        selectedDays: getFormattedEventDates(state),
        accentColor: state.ui.styleVars.GLOBAL__COLOR__ACCENT,
        loading: calendarLoading(state),
        fullLoading: inventoryFilterLoading(state),
        currentMonth: state.ui.currentMonth,
        hasSchedule,
        inventoryFilterResults: state.inventoryFilter.filterResults,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setWidth,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SeriesDayPicker);
